export const SettleType = {
	ACCOUNT: 'account', // 轉帳
	CASH: 'cash', // 現金
}

export const State = {
	CLOSED: 0,		// 已關閉
	OPENING: 1,		// 開啟中
	VERIFYING: 2,	// 審核中
	WAITING: 3,		// 待修改
}
